import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api.js";
import type { TestResultType } from "@templestay/db";

export function useTestResult(testSlug: string | undefined, resultSlug: string | undefined) {
  return useQuery({
    queryKey: ["test-result", testSlug, resultSlug],
    queryFn: async () => {
      if (!testSlug || !resultSlug) return null;
      const data = await api.get<{ resultType: TestResultType | null }>(
        `/api/tests/slug/${testSlug}/result/${resultSlug}`
      );
      return data.resultType;
    },
    enabled: !!testSlug && !!resultSlug,
    staleTime: 1000 * 60 * 30,
  });
}
